import { Component, ViewEncapsulation, ApplicationRef, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { NgClass, KeyValuePipe } from '@angular/common';

@Component({
  selector: 'ft-dialog-component',
  templateUrl: 'ft-dialog-component.html',
  styleUrls: ['ft-dialog-component.scss'],
  imports: [NgClass, MatDialogModule, MatButtonModule, MatIconModule, MatFormFieldModule, MatInputModule, FormsModule, MatSelectModule, MatOptionModule, MatRadioModule, MatCheckboxModule, KeyValuePipe]
})
export class DialogComponent {
  private dialogRef = inject<MatDialogRef<DialogComponent>>(MatDialogRef);
  private app = inject(ApplicationRef);
  data = inject(MAT_DIALOG_DATA) ?? {};

  inputValue: any;

  constructor() {
    if (this.data.input) {
      this.inputValue = this.data.inputValue;
    }

    this.dialogRef.backdropClick().subscribe(() => {
      this.app.tick();
    });

    setTimeout(() => {
      this.app.tick();
    });
  }

  cancel() {
    if (this.data.errorFunc) {
      this.data.errorFunc();
    }
    this.dialogRef.close();
  }

  discard() {
    if (this.data.discardFunc) {
      this.data.discardFunc();
    }
    this.dialogRef.close();
  }

  async ok() {
    if (this.data.succFunc) {
      try {
        await this.data.succFunc();
      } catch (e) {
        console.error('Error calling success function: ', e);
      }
    }
    this.dialogRef.close(this.inputValue);
  }

  onEnter(event: Event) {
    event.preventDefault();
    if (this.data.allowEnterKey !== false) {
      this.ok();
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }

  getButtonColor(): string {
    if (this.data.messageType === 'error' || (this.data.errorFunc && this.data.messageType !== 'warning')) {
      return 'warn';
    } else if (this.data.messageType === 'warning') {
      return 'primary'; // Use primary color for warning OK button (brand color)
    } else if (this.data.messageType === 'success') {
      return 'primary';
    } else if (this.data.messageType === 'info') {
      return 'primary';
    } else if (this.data.messageType === 'ft-about-us') {
      return 'primary';
    } else {
      return 'primary';
    }
  }
}
